import { render, staticRenderFns } from "./PostEcharts.vue?vue&type=template&id=8f38645a"
import script from "./PostEcharts.vue?vue&type=script&lang=js"
export * from "./PostEcharts.vue?vue&type=script&lang=js"
import style0 from "./PostEcharts.vue?vue&type=style&index=0&id=8f38645a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports